// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore, setLogLevel } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";

setLogLevel("debug");

const firebaseConfig = {
  apiKey: "AIzaSyCn4Q92TvMrYUIlNrpAUzsyfTuiJb1vvyY",
  authDomain: "bomberos-huasco.firebaseapp.com",
  projectId: "bomberos-huasco",
  storageBucket: "bomberos-huasco.firebasestorage.app",
  messagingSenderId: "410418404508",
  appId: "1:410418404508:web:ea77883eff26cdaae16159",
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export const authReady = new Promise((resolve, reject) => {
  let done = false;
  onAuthStateChanged(auth, async (user) => {
    try {
      if (user && !done) {
        done = true;
        return resolve(user);
      }
      if (!user) {
        const cred = await signInAnonymously(auth);
        if (!done) {
          done = true;
          resolve(cred.user);
        }
      }
    } catch (e) {
      if (!done) {
        done = true;
        reject(e);
      }
    }
  });
});

export default app;
